// extracted by mini-css-extract-plugin
export var quantityInput = "_kt-0";